import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'removeWhiteSpace' })
export class RemoveWhiteSpacePipe implements PipeTransform {
  transform(value: string, args?: any): string {
    return value.replace(/ /g, '');
  }
}
